import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ICampaignComposeSlice,
  ICampaignSenderDetails,
  IMediaDetails,
  ITemplate,
  ITemplatePlaceholderValues,
  TApiStatus,
  EMediaType,
} from "../../types/campaign.types";

export const defaultSenderDetails: ICampaignSenderDetails = {
  name: "",
  email: "",
  number: "",
  profilePic: "",
  countryCode: "",
  id: "",
};

const initialState: ICampaignComposeSlice = {
  mediaDetails: {
    addMediaFlag: false,
    mediaType: EMediaType.TEXT,
    uploadedFile: null,
    mediaFileName: "",
    mediaFileSize: "",
  },
  templateDetails: {
    templates: [],
    selectedTemplate: null,
    fetchStatus: "idle",
  },
  templatePlaceholders: {},
  campaignSenderDetails: defaultSenderDetails,
  templatesPlaceholderCache: {},
};

const campaignComposeSlice = createSlice({
  name: "campaignCompose",
  initialState,
  reducers: {
    setMediaDetails(
      state,
      action: PayloadAction<{ mediaDetails: IMediaDetails }>
    ) {
      state.mediaDetails = action.payload.mediaDetails;
    },

    setSelectedTemplate(
      state,
      action: PayloadAction<{ selectedTemplate: ITemplate | null }>
    ) {
      state.templateDetails.selectedTemplate = action.payload.selectedTemplate;
    },

    setCampaignSenderDetailsDetails(
      state,
      action: PayloadAction<{
        campaignSenderDetails: ICampaignSenderDetails;
      }>
    ) {
      state.campaignSenderDetails = action.payload.campaignSenderDetails;
    },

    setTemplates(state, action: PayloadAction<{ templates: ITemplate[] }>) {
      state.templateDetails.templates = action.payload.templates;
    },

    setTemplateFetchStatus(
      state,
      action: PayloadAction<{ status: TApiStatus }>
    ) {
      state.templateDetails.fetchStatus = action.payload.status;
    },

    setTemplatePlaceholders(
      state,
      action: PayloadAction<{ placeholders: ITemplatePlaceholderValues }>
    ) {
      state.templatePlaceholders = action.payload.placeholders;
    },

    setTemplatesPlaceholderCache(
      state,
      action: PayloadAction<{
        placeholders: ITemplatePlaceholderValues;
        template: ITemplate;
      }>
    ) {
      const { template, placeholders } = action.payload;
      if (template && placeholders) {
        let templatesPlaceholderCacheCopy = {
          ...state.templatesPlaceholderCache,
        };
        templatesPlaceholderCacheCopy[`${template.id}`] = {
          template,
          placeholders,
        };

        state.templatesPlaceholderCache = templatesPlaceholderCacheCopy;
      }
    },

    resetTemplatesPlaceholderCache(state) {
      state.templatesPlaceholderCache = {};
    },

    setDetailsFromDraft(
      state,
      action: PayloadAction<{
        mediaType?: EMediaType;
        uploadedFile?: File;
        mediaFileName?: string;
        mediaFileSize?: string;
        selectedTemplate?: ITemplate;
      }>
    ) {
      const {
        mediaFileName,
        mediaFileSize,
        mediaType,
        uploadedFile,
        selectedTemplate,
      } = action.payload;

      if (mediaFileName) {
        state.mediaDetails.mediaFileName = mediaFileName;
      }
      if (mediaFileSize) {
        state.mediaDetails.mediaFileSize = mediaFileSize;
      }
      if (mediaType) {
        state.mediaDetails.mediaType = mediaType;
      }

      if (uploadedFile) {
        state.mediaDetails.uploadedFile = uploadedFile;
      }
      if (selectedTemplate) {
        state.templateDetails.selectedTemplate = selectedTemplate;
      }
    },
  },
});

const campaignComposeReducer = campaignComposeSlice.reducer;
const campaignComposeActions = campaignComposeSlice.actions;

export { campaignComposeActions };
export default campaignComposeReducer;
